import * as Common from "../../commons/common"

export class StudentSubject {
  subject_code: string
  nendo: number
  unit: number
  report_count: number
  subject_name: string
  
  constructor(subject_code: string, nendo: number, unit: number, report_count: number, subject_name: string){
    this.subject_code = subject_code;
    this.nendo = nendo;
    this.unit = unit;
    this.report_count = report_count;
    this.subject_name = subject_name;
  }
}

export class StudentSheet {
  id: number
  base_sheet_id: number = null
  times: number = null
  status: number = null
  score: number = null
  submitted_at: string = null

  constructor(x: any){
    if(x){
      this.id = x.id;
      this.base_sheet_id = x.base_sheet_id;
      this.times = x.times;
      this.status = x.status;
      this.score = x.score;
      this.submitted_at = `${Common.formatDate(x.submitted_at, 'Y年M月D日')} 提出`;
    }
  }
}

export class StudentSubjectRow {
  studentSubject: StudentSubject
  studentSheets: StudentSheet[]
  baseSheets: any[]
  examStudentSheets: StudentSheet[]
  examBaseSheets: any[]
  supplementaryExamStudentSheets: StudentSheet[]
  supplementaryExamBaseSheets: any[]
  isDisp: boolean = false

  constructor(x: any){
    this.studentSubject = new StudentSubject(x.subject_code, x.nendo, x.unit, x.report_count, x.subject_name);
    this.studentSheets = x.student_sheets.map((y: any) => y ? new StudentSheet(y) : null);
    this.baseSheets = x.base_sheets;
    // 旧APIレスポンスでも過去のレポート一覧を表示できるよう、新設配列は空配列として扱う
    this.examStudentSheets = (x.exam_student_sheets || []).map((y: any) => y ? new StudentSheet(y) : null);
    this.examBaseSheets = x.exam_base_sheets || [];
    this.supplementaryExamStudentSheets = (x.supplementary_exam_student_sheets || []).map((y: any) => y ? new StudentSheet(y) : null);
    this.supplementaryExamBaseSheets = x.supplementary_exam_base_sheets || [];
  }
}
